window._define('widgets/dismissibleElement', ['jquery', 'widgets/baseWidget'], function ($, BaseWidget) {
    'use strict';

    $.widget('OC.dismissibleElement', BaseWidget, {

        options: {
            data: null,
            deleteUrl: '', // ajax call when user dismiss the box
            callback: $.noop,
        },

        _create: function () {
            this._super();

            this.elements.$closeBt = $('.close-button, .js-close-button', this.element).first();

            if (!this.elements.$closeBt.length) {
                $('<a class="close-button">×</a>').appendTo(this.element);
            }

            if (this.options.data) {
                this.data = this.options.data;
            }
            this._attachEvents();
        },

        _attachEvents: function () {
            var self = this;
            this.elements.$closeBt.on('click', function (event) {
                event.preventDefault();
                event.stopPropagation();

                self.dismiss();
            });
        },

        dismiss: function () {
            var self = this,
                url = this.options.deleteUrl,
                elem = this.element;

            if (url) {
                $.ajax(url);
            }

            elem.fadeOut(500, function () {
                elem.remove();
                $.proxy(self.options.callback, self)();
            });
        },

    });

    return $.OC.dismissibleElement;

});
